// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"f988f33c","72":"b0466076","235":"a1f248e5","383":"751d6e2e","396":"fb49b9e9","420":"b5c9ac66","453":"20359781","528":"e3af6de6","771":"ac8f50e7"}[chunkId] + ".chunk.js";
};